/*
 * (c) Copyright Reserved EVRYTHNG Limited 2021. All rights reserved.
 * Use of this material is subject to license.
 * Copying and unauthorised use of this material strictly prohibited.
 */

import i18n from '../_snowpack/pkg/i18next.js';
import LanguageDetector from '../_snowpack/pkg/i18next-browser-languagedetector.js';
import HttpApi from '../_snowpack/pkg/i18next-http-backend.js';
import { initReactI18next } from '../_snowpack/pkg/react-i18next.js';
import { request } from './requestTranslations.js';

/**
 * @typedef I18nextOptions
 * @type {object}
 * @property {string} defaultNS - default namespace.
 * @property {array} supportedLngs - supported languages.
 *
 * @param {I18nextOptions} options
 *
 * @returns {any} i18next.
 */
export const init = (options = {}) => {
  const defaultNS = options.defaultNS || 'default';
  const supportedLngs = options.supportedLngs || ['en-GB'];

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(HttpApi)
    .init({
      detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: 'i18nextLng',
        caches: ['localStorage'],
      },

      fallbackLng: 'en-GB',
      // debug: true,

      // have a common namespace used around the full app
      ns: [defaultNS],
      defaultNS,
      load: 'currentOnly',
      // keySeparator: false, // we use content as keys
      supportedLngs,
      backend: {
        loadPath: './i18n/locales/{{lng}}/{{ns}}.json',
        request,
      },
      interpolation: {
        escapeValue: false,
      },
    });
  return i18n;
};

export default i18n;
